// ============================================================
// VCS.DatingDeck — Kartenstapel, Wischen, Match
// ============================================================
// Pendant zu dating_deck_screen.dart (Stapel-Teil; das Radar ist in der PWA
// eine eigene View, siehe dating-radar.js).
//
// Nie ihren Ort: keine Distanz, keine Richtung, keine Karte. Der Server liefert
// das gar nicht erst aus -- hier gibt es kein Feld dafuer.
// ============================================================
window.VCS = window.VCS || {};

VCS.DatingDeck = class {

    // ── Konstanten ───────────────────────────────────────────

    // Ab hier zaehlt es als Entscheidung. Darunter federt die Karte zurueck.
    static SWIPE_THRESHOLD = 110;

    // Kippen beim Ziehen: dx/2600 rad -- dieselbe Physik wie in der App.
    static ROTATE_DIVISOR = 2600;

    // Bis hierhin ist es ein Tipp (oeffnet das Profil), darueber ein Wisch. Bewusst
    // klein: Ein Finger wackelt beim Tippen um ein paar Pixel, aber wer wischen will,
    // bewegt sich deutlich weiter.
    static TAP_SLOP = 8;

    // ── Konstruktor ──────────────────────────────────────────

    constructor() {
        this._view = {
            body: $('#datingDeckBody')
        };

        this._profile = null;
        this._deck    = [];
        this._remote  = false;
        this._error   = '';
        this._busy    = false;

        // photoHash -> Blob-URL. Dating-Fotos brauchen den Auth-Header, ein
        // blankes <img src> bekaeme 401.
        this._photoUrls = new Map();

        // Welches der bis zu drei Fotos die oberste Karte zeigt. Gehoert der Karte,
        // nicht dem Kandidaten: Die naechste faengt wieder bei ihrem ersten an.
        this._photoIndex = 0;

        this._drag     = { x: 0, y: 0 };
        this._start    = { x: 0, y: 0 };
        this._dragging = false;

        // „Mögen dich"-Modus: derselbe Stapel, aber gegen /dating/likes — nur Leute, die
        // mich schon geliked haben. Kein Ort, kein Fern/Nah; ein Rechts-Wisch matcht sofort.
        this._likesMe = false;
    }

    init() {
        this._bindEvents();
    }

    // ── Lifecycle ────────────────────────────────────────────

    // [likesMode] setzt dieselbe Deck-View in den „Mögen dich"-Modus. dating-ui.js gibt es
    // beim Betreten der Ansicht durch — „likes" ist keine eigene View, sondern dieser Stapel
    // mit einem anderen Query und Titel.
    async onShow(likesMode) {
        this._likesMe = !!likesMode;
        this._applyTitle();

        // Vom Radar uebernommen: Daten stehen schon, nur noch das Foto der
        // obersten Karte holen. Ein Neuladen wuerde die Reihenfolge zerstoeren,
        // die der Tipp im Radar gerade festgelegt hat. (Nie im Mögen-dich-Modus.)
        if (this._adopted) {
            this._adopted = false;
            this._photoIndex = 0;
            await this._ensureAllPhotos(this._deck[0]);
            this._render();
            this._ensurePhoto(this._deck[1]);
            return;
        }
        // Direkt ueber „Swipen" betreten — dann fuehrt Zurueck auch zur Startseite.
        this._fromRadar = false;
        await this._init();
    }

    // Der Titel im Deck-Header. data-i18n mitsetzen, damit ein Sprachwechsel den richtigen
    // Text nimmt (applyLang liest das Attribut).
    _applyTitle() {
        const key = this._likesMe ? 'datingHomeLikes' : 'datingDeckTitle';
        $('#datingViewDeck .chat-header-title').attr('data-i18n', key).text(t(key));
    }

    // Ein Punkt im Radar wurde angetippt: Diese Person kommt nach vorn, dann
    // uebernimmt der Stapel. Die anderen bleiben dahinter stehen — wer im Radar
    // war, verschwindet nicht, nur weil man jemand anderen zuerst ansieht.
    // candidate = null: „Nacheinander durchgehen", Reihenfolge bleibt.
    adoptFromRadar(deck, candidate) {
        const list = (deck || []).slice();
        this._deck = candidate
            ? [candidate].concat(list.filter((c) => c.handle !== candidate.handle))
            : list;
        this._remote    = false;   // Das Radar ist immer Nah.
        this._error     = '';
        this._fromRadar = true;
        this._adopted   = true;
    }

    // Wer ueber das Radar in den Stapel gegangen ist, kommt auch dorthin zurueck
    // — Schritt fuer Schritt dorthin, wo er hergekommen ist.
    cameFromRadar() {
        return this._fromRadar === true;
    }

    // Wen der Nutzer gerade ansieht: die oberste Karte. Das Radar fragt danach,
    // bevor es auf radar-gone einen Blip entfernt — wer liest, soll zu Ende
    // lesen duerfen.
    currentHandle() {
        return this._deck.length ? (this._deck[0].handle || '') : '';
    }

    onHide() {
        this.closeMatchOverlay();
        // Sonst zeigt das Overlay Blob-URLs an, die _releaseUrls() gleich einzieht — und
        // beim naechsten Betreten haengt ein Profil ueber dem frischen Stapel.
        this.closeCandidateOverlay();
        this._releaseUrls();
    }

    onLangChange() {
        if (VCS.dating?.currentView?.() === 'deck' && VCS.dating?.isOpen?.()) {
            this._render();
            // Das Profil-Overlay haengt an #datingScreen und liegt ueber dem Stapel —
            // _render() erreicht es nicht. Ohne das hier bliebe es in der alten Sprache
            // stehen, waehrend die Karte darunter schon die neue spricht.
            if (this._candOverlay) {
                const c = this._deck.find((x) => x.handle === this._candHandle);
                if (c) {
                    this._showCandidate(c);
                } else {
                    // Die Person ist inzwischen aus dem Stapel gelaufen (geswipt,
                    // radar-gone). Dann gibt es nichts mehr zu zeigen.
                    this.closeCandidateOverlay();
                }
            }
        }
    }

    async _init() {
        this._renderLoading();
        this._error = '';

        const profile = await VCS.datingCore.getProfile();
        if (!profile) {
            this._error = 'no_profile';
            this._render();
            return;
        }
        this._profile = profile;
        // „Mögen dich" ist immer ortsunabhaengig. Sonst: Wer nur Fern eingestellt hat,
        // startet auch dort — sonst kaeme sofort ein mode_mismatch, fuer den er nichts kann.
        this._remote = this._likesMe ? false : (profile.mode === 'remote');
        await this._loadDeck();
    }

    async _loadDeck() {
        this._renderLoading();
        this._error = '';

        // Der Stapel braucht einen Standort nur, wenn ein Umkreis gesetzt ist: „50 km
        // von hier" kann der Server nicht beantworten, wenn er das „hier" nicht kennt.
        // Bei „Beides" ist der Ort egal, im Fern-Modus zaehlt das Land, und am Anschlag
        // („egal") wird ohnehin nicht gefiltert.
        //
        // Und es ist kein Fehler mehr, wenn die Ortung nicht klappt: Dann faellt der
        // Umkreis weg und man sieht alle, statt vor einer Fehlerseite zu sitzen — der
        // Server filtert ohne eigene Zelle nicht (deckDistanceOk in routes.js). Bis
        // 17.07. ortete der Stapel immer und brach hier mit `no_location` ab: Wer im
        // Browser die Standortfrage wegklickte, kam nicht einmal zum Blaettern.
        //
        // Frisch bei jedem Laden — man bewegt sich ja. Gerundet wird auf die Stufe aus
        // dem Profil; der Server kuerzt ohnehin darauf.
        // „Mögen dich" ortet nie — der Server filtert dort nicht nach Ort.
        const needsCell = !this._likesMe
            && !this._remote
            && this._profile?.mode === 'local'
            && (this._profile?.seekRadiusKm || VCS.DatingCore.RADIUS_ANY) < VCS.DatingCore.RADIUS_ANY;
        if (needsCell) {
            await VCS.datingGeo.syncCell(this._profile?.cellPrecision);
        }

        // Ohne fresh: Der Stapel fragt "wer ist in der Gegend", nicht "wer ist
        // jetzt hier" — mit Praesenz-Fenster waere er fast immer leer. Im Mögen-dich-Modus
        // fragt getDeck stattdessen /dating/likes.
        const result = await VCS.datingCore.getDeck(this._remote, false, this._likesMe);
        this._deck  = result.deck || [];
        this._error = result.ok ? '' : (result.error || 'unknown');

        // Von der obersten Karte ALLE Fotos (sie haengen als Vorschau darunter), von
        // der dahinter nur das erste: Beim Wischen muss sie sofort stehen, sonst blitzt
        // eine leere Karte auf — ihre weiteren Fotos holt dann ihr eigener Auftritt.
        this._photoIndex = 0;
        await this._ensureAllPhotos(this._deck[0]);
        this._render();
        this._ensurePhoto(this._deck[1]);
    }

    // ── Fotos ────────────────────────────────────────────────

    // Laedt EIN Foto (Standard: das erste). Bis 17.07. gab es nur diesen Fall — der
    // Stapel zeigte immer photos[0], die anderen beiden wurden hochgeladen, ausgeliefert
    // und weggeworfen.
    async _ensurePhoto(candidate, index) {
        const hash = candidate && candidate.photos && candidate.photos[index || 0];
        if (!hash || this._photoUrls.has(hash)) {
            return;
        }
        // Platz sofort belegen, damit zwei parallele Aufrufe nicht zweimal laden.
        this._photoUrls.set(hash, '');
        const url = await VCS.datingCore.loadPhotoUrl(hash);
        this._photoUrls.set(hash, url);
    }

    // Alle Fotos der obersten Karte — sie haengen als Vorschau darunter und muessen
    // sofort stehen. Es sind hoechstens drei (DATING_MAX_PHOTOS), also kein Grund,
    // hier zu geizen. Nacheinander statt parallel: Der Blob-Cache belegt seinen Platz
    // erst nach dem await, gleichzeitige Aufrufe fuer denselben Hash laedt sonst
    // jeder fuer sich.
    async _ensureAllPhotos(candidate) {
        const list = (candidate && candidate.photos) || [];
        for (let i = 0; i < list.length; i++) {
            await this._ensurePhoto(candidate, i);
        }
    }

    _photoUrl(candidate, index) {
        const hash = candidate && candidate.photos && candidate.photos[index || 0];
        return hash ? (this._photoUrls.get(hash) || '') : '';
    }

    _releaseUrls() {
        for (const url of this._photoUrls.values()) {
            VCS.datingCore?.releasePhotoUrl?.(url);
        }
        this._photoUrls.clear();
    }

    // ── Rendern ──────────────────────────────────────────────

    _renderLoading() {
        this._view.body.html('<div class="dating-loading"><div class="dating-spinner"></div></div>');
    }

    _render() {
        if (this._error) {
            this._renderError();
            return;
        }
        if (!this._deck.length) {
            this._renderEmpty();
            return;
        }
        this._renderCards();
    }

    // Hier stand bis 17.07. ein Nah/Fern-Umschalter fuer mode = 'both'. Er ist weg:
    // „Beides" heisst „zeig mir alle", nicht „lass mich zwischen zwei Listen blaettern"
    // — der Server liefert bei mode=both einen Stapel mit allen (getDatingDeckAll).
    //
    // Er hatte ohnehin eine schiefe Kante: „Nah" hiess 3,7 km, „Fern" hiess anderes Land
    // — wer in derselben Stadt wohnte, aber nicht im selben Viertel, fiel durch beide
    // Raster und war nirgends zu sehen.

    _errorInfo() {
        return VCS.DatingDeck.errorInfo(this._error);
    }

    // Jeder Fall sagt, was wirklich los ist. Ein pauschales „du bist nicht
    // sichtbar" fuehrt in die Irre, wenn in Wahrheit der Server nicht erreichbar
    // ist. (In der App genau so passiert.)
    //
    // Statisch, weil das Radar dieselben Faelle hat — es hat keine eigenen.
    static errorInfo(code) {
        switch (code) {
            case 'no_location':
            case 'no_cell':
                return { title: t('datingDeckNoCell'), body: t('datingDeckNoCellHint'),
                         action: t('datingDeckAllowLocation'), go: 'retry' };
            case 'no_profile':
                return { title: t('datingDeckNoProfile'), body: t('datingDeckNoProfileHint'),
                         action: t('datingDeckToProfile'), go: 'profile' };
            case 'inactive':
                return { title: t('datingDeckInactive'), body: t('datingDeckInactiveHint'),
                         action: t('datingDeckToProfile'), go: 'profile' };
            // Ohne eigene Absicht kann sich keine ueberschneiden — der Stapel
            // waere zwangslaeufig leer.
            case 'no_intent':
                return { title: t('datingDeckNoIntent'), body: t('datingDeckNoIntentHint'),
                         action: t('datingDeckToProfile'), go: 'profile' };
            // Kein Serverfehler, sondern eine Einstellung — also auch kein
            // Serverfehler-Text.
            case 'mode_mismatch':
                return { title: t('datingDeckModeMismatch'), body: t('datingDeckModeMismatchHint'),
                         action: t('datingDeckToProfile'), go: 'profile' };
            default:
                // network, unknown und alles Unerwartete: ehrlich bleiben und den
                // Code mitgeben.
                return { title: t('datingDeckNoServer'),
                         body: t('datingDeckNoServerHint') + '\n\n(' + code + ')',
                         action: t('datingRetry'), go: 'retry' };
        }
    }

    _renderError() {
        const info = this._errorInfo();
        this._view.body.html(
            '<div class="dating-state">'
            + '<h3 class="dating-state-title">' + escapeHtml(info.title) + '</h3>'
            + '<p class="dating-state-body">' + escapeHtml(info.body) + '</p>'
            + '<button type="button" class="dating-save dating-state-btn" data-dating-deck-go="'
            + escapeHtml(info.go) + '">' + escapeHtml(info.action) + '</button>'
            + '</div>'
        );
    }

    _renderEmpty() {
        this._view.body.html(
            '<div class="dating-state">'
            + '<div class="dating-state-icon">'
            + '<svg viewBox="0 0 24 24" width="48" height="48" stroke="currentColor" stroke-width="1.5" fill="none">'
            + '<path d="M5 22h14"></path><path d="M5 2h14"></path>'
            + '<path d="M17 22v-4.172a2 2 0 0 0-.586-1.414L12 12l-4.414 4.414A2 2 0 0 0 7 17.828V22"></path>'
            + '<path d="M7 2v4.172a2 2 0 0 0 .586 1.414L12 12l4.414-4.414A2 2 0 0 0 17 6.172V2"></path>'
            + '</svg></div>'
            + '<h3 class="dating-state-title">'
            + escapeHtml(t(this._likesMe ? 'datingLikesEmpty' : 'datingDeckEmpty')) + '</h3>'
            + '<p class="dating-state-body">'
            + escapeHtml(t(this._likesMe ? 'datingLikesEmptyHint' : 'datingDeckEmptyHint')) + '</p>'
            + '<button type="button" class="dating-save dating-state-btn" data-dating-deck-go="retry">'
            + escapeHtml(t('datingRetry')) + '</button>'
            // Ohne das kommt man aus dem leeren Stapel nicht mehr an sein Profil.
            + '<button type="button" class="dating-state-link" data-dating-deck-go="profile">'
            + escapeHtml(t('datingDeckToProfile')) + '</button>'
            + '</div>'
        );
    }

    _renderCards() {
        const c = this._deck[0];
        this._view.body.html(
            '<div class="dating-card-area">' + this._cardHtml(c) + '</div>'
            + this._thumbsHtml(c)
            + '<div class="dating-decide">'
            + '<div class="dating-decide-col">'
            // Der graue Knopf ist im hellen Theme fast weiss — ein weisses Icon
            // darauf waere unsichtbar. Deshalb traegt er die Textfarbe.
            + '<button type="button" class="dating-decide-btn dating-decide-btn--nope" data-dating-decide="0">'
            + '<svg viewBox="0 0 24 24" width="28" height="28" stroke="currentColor" stroke-width="2.5" fill="none">'
            + '<path d="M18 6L6 18"></path><path d="M6 6l12 12"></path></svg></button>'
            + '<span class="dating-decide-label">' + escapeHtml(t('datingNope')) + '</span>'
            + '</div>'
            + '<div class="dating-decide-col">'
            + '<button type="button" class="dating-decide-btn dating-decide-btn--like" data-dating-decide="1">'
            + '<svg viewBox="0 0 24 24" width="28" height="28" fill="currentColor">'
            + '<path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>'
            + '</svg></button>'
            + '<span class="dating-decide-label">' + escapeHtml(t('datingLike')) + '</span>'
            + '</div>'
            + '</div>'
        );
        this._attachDrag();
    }

    // Die weiteren Fotos als Vorschau unter der Karte — Tipp waehlt aus.
    //
    // Entscheidung des Users (17.07.), bewusst anders als das Genre: Tinder & Co.
    // blaettern durch Tippen auf die Kartenhaelften, mit Strichen als einzigem Hinweis.
    // Das spart Flaeche, aber man muss WISSEN, dass es mehr Fotos gibt. Hier sieht man
    // es — „ich will ja nicht Tinder nachmachen".
    //
    // Bei nur einem Foto bleibt die Reihe weg: ein einzelnes Kaestchen, das nichts
    // umschaltet, waere eine Behauptung ohne Inhalt.
    _thumbsHtml(c) {
        const list = (c && c.photos) || [];
        if (list.length < 2) {
            return '';
        }
        const idx = Math.min(this._photoIndex, list.length - 1);
        const items = list.map((hash, i) => {
            const url = this._photoUrls.get(hash) || '';
            return '<button type="button" class="dating-thumb' + (i === idx ? ' is-active' : '') + '"'
                + ' data-dating-thumb="' + i + '"'
                + ' aria-label="' + escapeHtml(t('datingPhotos')) + ' ' + (i + 1) + '">'
                + (url ? '<img src="' + escapeHtml(url) + '" alt="">' : '')
                + '</button>';
        }).join('');
        return '<div class="dating-thumbs">' + items + '</div>';
    }

    _cardHtml(c) {
        // Geklemmt statt blind indiziert: Der Index gehoert der Karte, die Fotos dem
        // Kandidaten — beim Nachladen kann die neue Karte weniger Fotos haben als die
        // alte, und dann zeigte [2] auf nichts.
        const idx  = Math.min(this._photoIndex, Math.max(0, (c.photos || []).length - 1));
        const url  = this._photoUrl(c, idx);
        const age  = c.birthYear > 0 ? (new Date().getUTCFullYear() - c.birthYear) : 0;
        const name = age > 0 ? (c.displayName + ', ' + age) : c.displayName;

        const parts = [];
        parts.push('<div class="dating-card">');
        // Fremdtexte (Name, Bio) -- escapeHtml ist hier Pflicht, das ist die
        // klassische XSS-Stelle.
        if (url) {
            parts.push('<img class="dating-card-photo" src="' + escapeHtml(url) + '" alt="">');
        } else {
            parts.push('<div class="dating-card-photo dating-card-photo--none">'
                + '<svg viewBox="0 0 24 24" width="64" height="64" stroke="currentColor" stroke-width="1.5" fill="none">'
                + '<path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>'
                + '<circle cx="12" cy="7" r="4"></circle></svg></div>');
        }
        // Verlauf, damit der Text auf hellen Fotos lesbar bleibt.
        parts.push('<div class="dating-card-shade"></div>');
        parts.push('<div class="dating-card-info">');
        parts.push('<div class="dating-card-name">' + escapeHtml(name) + '</div>');
        // Sternzeichen direkt unter den Namen -- wie im Detail-Screen. Nur wenn Monat/Tag
        // gesetzt sind (sonst gibt zodiac() null). Gleiches Format: Emoji + uebersetztes Label.
        const cardZodiac = VCS.DatingCore.zodiac(c.birthMonth, c.birthDay);
        if (cardZodiac) {
            parts.push('<div class="dating-card-meta dating-card-zodiac">'
                + escapeHtml(cardZodiac.emoji + ' ' + t('datingZodiac_' + cardZodiac.key)) + '</div>');
        }
        if (c.country) {
            parts.push('<div class="dating-card-meta">'
                + escapeHtml(VCS.DatingCore.COUNTRIES[c.country] || c.country) + '</div>');
        }
        if (c.langs && c.langs.length) {
            const names = c.langs.map((l) => LANG_NAMES[l] || String(l).toUpperCase()).join(', ');
            parts.push('<div class="dating-card-meta">'
                + escapeHtml(t('datingSpeaks') + ': ' + names) + '</div>');
        }
        parts.push('<div class="dating-card-bio">' + escapeHtml(c.bio || '') + '</div>');
        parts.push('</div>');

        // Stempel: erscheinen mit der Geste, damit man vor dem Loslassen sieht,
        // was passieren wird. Liegen auf dem Foto, nicht auf der App — deshalb
        // hier keine Theme-Farbe: Ein Foto ist mal hell, mal dunkel, und Weiss
        // bleibt darauf immer lesbar.
        parts.push('<span class="dating-stamp dating-stamp--like">' + escapeHtml(t('datingLike')) + '</span>');
        parts.push('<span class="dating-stamp dating-stamp--nope">' + escapeHtml(t('datingNope')) + '</span>');
        parts.push('</div>');
        return parts.join('');
    }

    // ── Wischen ──────────────────────────────────────────────

    // Pointer-Events statt Touch: deckt Finger und Maus in einem ab. Ohne
    // touch-action:none (CSS) scrollt der Browser die Seite mit.
    _attachDrag() {
        const el = this._view.body.find('.dating-card')[0];
        if (!el) {
            return;
        }

        el.addEventListener('pointerdown', (e) => {
            if (this._busy) {
                return;
            }
            this._dragging = true;
            this._moved    = false;
            this._start = { x: e.clientX, y: e.clientY };
            this._drag  = { x: 0, y: 0 };
            el.style.transition = 'none';
            try { el.setPointerCapture(e.pointerId); } catch (_) {}
        });

        el.addEventListener('pointermove', (e) => {
            if (!this._dragging) {
                return;
            }
            this._drag = { x: e.clientX - this._start.x, y: e.clientY - this._start.y };
            // Ab hier war es ein Wisch und kein Tipp. Flutter hat dafuer die
            // Gesten-Arena, die Tap und Pan von selbst trennt — im Browser gibt es die
            // nicht: Nach einem Drag feuert `click` je nach Engine trotzdem. Ohne diese
            // Schwelle oeffnet jeder Wisch zusaetzlich das Profil.
            if (Math.abs(this._drag.x) > VCS.DatingDeck.TAP_SLOP
                || Math.abs(this._drag.y) > VCS.DatingDeck.TAP_SLOP) {
                this._moved = true;
            }
            this._applyDrag(el);
        });

        // Tipp auf die Karte: das ganze Profil. Liegt am selben Element wie das Wischen,
        // deshalb der Guard oben.
        el.addEventListener('click', () => {
            if (this._moved || this._busy || !this._deck.length) {
                return;
            }
            this._showCandidate(this._deck[0]);
        });

        const end = () => {
            if (!this._dragging) {
                return;
            }
            this._dragging = false;
            if (Math.abs(this._drag.x) >= VCS.DatingDeck.SWIPE_THRESHOLD) {
                this._decide(this._drag.x > 0);
                return;
            }
            // Zu zaghaft — zurueck in die Mitte, keine Entscheidung.
            el.style.transition = 'transform 220ms cubic-bezier(0.22, 1, 0.36, 1)';
            this._drag = { x: 0, y: 0 };
            this._applyDrag(el);
        };
        el.addEventListener('pointerup', end);
        el.addEventListener('pointercancel', end);
    }

    _applyDrag(el) {
        const d = this._drag;
        el.style.transform = 'translate(' + d.x + 'px, ' + (d.y * 0.4) + 'px)'
            + ' rotate(' + (d.x / VCS.DatingDeck.ROTATE_DIVISOR) + 'rad)';

        const progress = Math.min(Math.abs(d.x) / VCS.DatingDeck.SWIPE_THRESHOLD, 1);
        const like = el.querySelector('.dating-stamp--like');
        const nope = el.querySelector('.dating-stamp--nope');
        if (like) { like.style.opacity = d.x > 0 ? progress : 0; }
        if (nope) { nope.style.opacity = d.x < 0 ? progress : 0; }
    }

    // ── Entscheidung ─────────────────────────────────────────

    async _decide(like) {
        if (!this._deck.length || this._busy) {
            return;
        }
        const candidate = this._deck[0];
        this._busy = true;

        // Karte sofort weg, nicht erst wenn der Server geantwortet hat — sonst
        // haengt die Geste an der Netzlatenz. Der Swipe ist ohnehin nicht
        // widerrufbar.
        this._deck = this._deck.slice(1);
        this._drag = { x: 0, y: 0 };
        this._dragging = false;
        // Die Naechste faengt bei ihrem ersten Foto an — der Index gehoert der Karte,
        // nicht dem Stapel. Sonst saehe man von ihr als Erstes ihr drittes Bild.
        this._photoIndex = 0;
        this._render();
        // Ihr erstes Foto steht schon (vorgeladen), die weiteren fuer die Vorschau
        // kommen jetzt — und danach das erste der naechsten Karte.
        this._ensureAllPhotos(this._deck[0]).then(() => {
            this._render();
            this._ensurePhoto(this._deck[1]);
        });

        const matched = await VCS.datingCore.swipe(candidate.handle, like);
        this._busy = false;
        if (matched) {
            this._showMatch(candidate);
        }
    }

    // ── Profil in ganzer Laenge ──────────────────────────────
    // Pendant zu dating_candidate_screen.dart.
    //
    // Befund des Users (17.07.): „Wenn ich auf ein Profil lande zum Bewerten, sehe ich
    // nicht viel. Ich weiss nicht, welche Absichten er hat." Auf der Karte stehen Foto,
    // Name, Land, Sprachen und ein paar Zeilen Bio — die ABSICHTEN kamen in jeder
    // Deck-Antwort mit und wurden hier weggeworfen. Dieselbe Form wie der Foto-Bug
    // (photos[0]): Der Server liefert, der Client zeigt es nicht.
    //
    // `mode` (WO jemand sucht) ist seit 17.07. dabei — auf Wunsch des Gruenders direkt
    // nachgezogen. Es fehlte in allen fuenf Deck-/Match-Queries (SELECT erweitert), also
    // war es der Rest desselben Befunds: „Ich weiss nicht, welche Absichten er hat. WO er
    // sucht, was er sucht."
    //
    // Overlay statt eigener View: Es liegt UEBER dem Stapel, der darunter stehen bleibt
    // (inkl. Reihenfolge und geladener Fotos). Eine View haette den Stapel verlassen und
    // beim Zurueckkommen neu geladen — die oberste Karte waere eine andere gewesen.

    // WO jemand sucht. Eigene Keys statt datingModeLocal & Co.: Die stehen im eigenen
    // Profil zur Auswahl und sprechen aus der Ich-Sicht („Leute in MEINER Naehe") — hier
    // geht es um jemand anderen, und fuer „seiner/ihrer" braeuchte man ein Geschlecht.
    //
    // Unbekannter Wert (neuerer Server, alter Client): nichts zeigen. Anders als bei den
    // Absichten hilft der rohe Wert hier niemandem — „hybrid" waere kein Satz.
    _modeLabel(mode) {
        switch (mode) {
            case 'local':  return t('datingModeOtherLocal');
            case 'remote': return t('datingModeOtherRemote');
            case 'both':   return t('datingModeOtherBoth');
            default:       return '';
        }
    }

    // Eine Angabe als Ueberschrift + Pills. accent=true macht die Absichten orange — sie
    // sind die Entscheidung; Land, Sprachen und Wo bekommen ruhige Pills. Leere Werte-Liste
    // = gar nichts (kein Titel ueber dem Nichts).
    _pillGroup(label, values, accent) {
        if (!values || !values.length) {
            return '';
        }
        const cls = accent ? 'dating-cand-chip dating-cand-chip--accent' : 'dating-cand-chip';
        let html = '<div class="dating-cand-label">' + escapeHtml(label) + '</div>'
            + '<div class="dating-cand-chips">';
        for (const v of values) {
            html += '<span class="' + cls + '">' + escapeHtml(v) + '</span>';
        }
        return html + '</div>';
    }

    _intentLabel(intent) {
        switch (intent) {
            case 'talk':         return t('datingIntentTalk');
            case 'relationship': return t('datingIntentRelationship');
            // Label heisst seit 17.07. „Etwas Unverbindliches"; der technische Wert
            // bleibt `sex` (DB, jsonb-Filter, API).
            case 'sex':          return t('datingIntentSex');
            // Ein Wert, den diese Version nicht kennt (neuerer Server, alter Client):
            // lieber roh zeigen als verschweigen — Verschweigen ist genau der Bug, den
            // diese Ansicht behebt.
            default:             return intent;
        }
    }

    // Aus der Match-Liste aufrufbar: showMatchProfile(c, urls) zeigt dasselbe Profil, aber
    // mit [Chat]/[Video] statt Like/Nope — die Entscheidung ist längst gefallen (Phase 5).
    showMatchProfile(c, photoUrls) {
        this._showCandidate(c, { match: true, photoUrls });
    }

    _showCandidate(c, opts) {
        opts = opts || {};
        const match = opts.match === true;
        // Fotos: aus dem Stapel der Deck-Cache, aus der Match-Liste deren eigener Cache.
        const urls = opts.photoUrls || this._photoUrls;
        this.closeCandidateOverlay();

        const list = (c.photos || []).filter((h) => urls.get(h));
        const age  = c.birthYear > 0 ? (new Date().getUTCFullYear() - c.birthYear) : 0;
        const name = age > 0 ? (c.displayName + ', ' + age) : (c.displayName || '');

        const parts = [];
        parts.push('<div class="dating-cand-panel">');

        // Kopf: Zurueck-Pfeil und Name. Eigener Knopf statt [data-dating-back] — der
        // fuehrt zur Startseite, hier geht es zurueck auf die Karte, von der man kam.
        parts.push('<div class="dating-cand-head">');
        parts.push('<button type="button" class="dating-cand-back" data-dating-cand-close'
            + ' aria-label="' + escapeHtml(t('back')) + '">'
            + '<svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none">'
            + '<path d="M19 12H5"></path><path d="M12 19l-7-7 7-7"></path></svg></button>');
        parts.push('<div class="dating-cand-title">' + escapeHtml(name) + '</div>');
        // Drei-Punkte-Menue: Melden/Blockieren. Bewusst hinter einem Menue und nicht als
        // Knopf neben "Interesse" -- selten gebraucht, und ein Melden-Knopf dort waere eine
        // Einladung zum Fehlgriff. Gilt im Stapel UND aus der Match-Liste (wie Flutter).
        parts.push('<button type="button" class="dating-cand-safety" data-dating-cand-safety'
            + ' aria-label="' + escapeHtml(t('datingSafetyMenu')) + '">'
            + '<svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor">'
            + '<circle cx="12" cy="5" r="2"></circle><circle cx="12" cy="12" r="2"></circle>'
            + '<circle cx="12" cy="19" r="2"></circle></svg></button>');
        parts.push('</div>');

        parts.push('<div class="dating-cand-scroll">');

        // Fotos: nativ wischbar per CSS scroll-snap, ohne JS-Slider. Laeuft auf
        // iOS-Safari genauso wie ueberall sonst — ein selbstgebauter Slider mit
        // Pointer-Events waere hier die schlechtere Wahl.
        if (list.length) {
            parts.push('<div class="dating-cand-photos">');
            for (const hash of list) {
                parts.push('<img src="' + escapeHtml(urls.get(hash) || '') + '" alt="">');
            }
            parts.push('</div>');
            // Punkte statt Vorschaubilder: Dass es mehr Fotos gibt, weiss hier jeder —
            // er hat das Profil ja geoeffnet. Bei einem Foto keine Punkte.
            //
            // Knoepfe, nicht nur Anzeige: Auf dem Handy blaettert man durch Wischen, am
            // Desktop wischt niemand — dort waren die Punkte eine Anzeige, die aussah wie
            // eine Bedienung (17.07., vom Gruender gemeldet).
            if (list.length > 1) {
                parts.push('<div class="dating-cand-dots">');
                for (let i = 0; i < list.length; i++) {
                    parts.push('<button type="button" class="dating-cand-dot' + (i === 0 ? ' is-active' : '') + '"'
                        + ' data-dating-cand-dot="' + i + '"'
                        + ' aria-label="' + escapeHtml(t('datingPhotos')) + ' ' + (i + 1) + '"></button>');
                }
                parts.push('</div>');
            }
        }

        parts.push('<div class="dating-cand-body">');

        // Alles als Pills mit Ueberschrift, damit jede Angabe gleich prominent ist. Nur
        // „Sucht" ist orange — das ist die Entscheidung; Land, Sprachen und Wo bleiben ruhig,
        // sonst sticht nichts mehr heraus (Entscheidung des Gruenders, 17.07.).
        const langNames = (c.langs || []).map((l) => LANG_NAMES[l] || String(l).toUpperCase());
        const modeLabel = this._modeLabel(c.mode);
        // Zusatzfelder (2026-07-18). Jeweils leer/0 -> _pillGroup zeigt gar nichts.
        const zodiac = VCS.DatingCore.zodiac(c.birthMonth, c.birthDay);
        parts.push(this._pillGroup(t('datingStarSign'),
            zodiac ? [zodiac.emoji + ' ' + t('datingZodiac_' + zodiac.key)] : []));
        parts.push(this._pillGroup(t('datingHeight'),
            c.heightCm > 0 ? [c.heightCm + ' cm'] : []));
        parts.push(this._pillGroup(t('datingFromLabel'),
            c.country ? [VCS.DatingCore.COUNTRIES[c.country] || c.country] : []));
        parts.push(this._pillGroup(t('datingSpeaks'), langNames));
        // Die Absichten sind der Grund fuer diese Ansicht, deshalb orange. Im Fern-Modus
        // leer (wer sich nie trifft, fuer den gibt es kein „nur Sex" — dating_plan.md).
        parts.push(this._pillGroup(t('datingSeeks'),
            (c.intents || []).map((i) => this._intentLabel(i)), true));
        parts.push(this._pillGroup(t('datingWhereLabel'), modeLabel ? [modeLabel] : []));
        parts.push(this._pillGroup(t('datingSmoking'),
            VCS.DatingCore.HABITS.includes(c.smoking) ? [t('datingHabit_' + c.smoking)] : []));
        parts.push(this._pillGroup(t('datingDrinking'),
            VCS.DatingCore.HABITS.includes(c.drinking) ? [t('datingHabit_' + c.drinking)] : []));
        parts.push(this._pillGroup(t('datingInterests'),
            (c.interests || []).map((key) => {
                const it = VCS.DatingCore.INTERESTS.find((x) => x.key === key);
                return it ? (it.emoji + ' ' + t('datingInterest_' + it.key)) : key;
            })));

        // Ganz, ohne Kuerzen. Auf der Karte ist die Bio beschnitten — wer bis hierher
        // getippt hat, will lesen.
        if (c.bio) {
            parts.push('<div class="dating-cand-bio">' + escapeHtml(c.bio) + '</div>');
        }
        parts.push('</div>');   // body
        parts.push('</div>');   // scroll

        // Im Stapel: Nope/Like wie unter der Karte. Aus der Match-Liste: Chat/Video — der
        // Match ist da, jetzt beginnt das Gespräch (Phase 5). Vor Video/Chat wird gefragt.
        parts.push('<div class="dating-decide">');
        if (match) {
            parts.push('<div class="dating-decide-col">');
            parts.push('<button type="button" class="dating-decide-btn dating-decide-btn--nope" data-dating-cand-chat>'
                + '<svg viewBox="0 0 24 24" width="26" height="26" stroke="currentColor" stroke-width="1.9" fill="none">'
                + '<path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"></path></svg></button>');
            parts.push('<span class="dating-decide-label">' + escapeHtml(t('datingChatAction')) + '</span>');
            parts.push('</div>');
            parts.push('<div class="dating-decide-col">');
            parts.push('<button type="button" class="dating-decide-btn dating-decide-btn--like" data-dating-cand-video>'
                + '<svg viewBox="0 0 24 24" width="26" height="26" stroke="currentColor" stroke-width="1.9" fill="none">'
                + '<path d="M23 7l-7 5 7 5V7z"></path><rect x="1" y="5" width="15" height="14" rx="2" ry="2"></rect></svg></button>');
            parts.push('<span class="dating-decide-label">' + escapeHtml(t('datingVideoCall')) + '</span>');
            parts.push('</div>');
            // „Finde mich"-Spiel: nur bei Matches, startet die beidseitige Freigabe.
            parts.push('<div class="dating-decide-col">');
            parts.push('<button type="button" class="dating-decide-btn dating-decide-btn--findme" data-dating-cand-findme>'
                + '<svg viewBox="0 0 24 24" width="26" height="26" stroke="currentColor" stroke-width="1.9" fill="none">'
                + '<circle cx="12" cy="12" r="3"></circle><circle cx="12" cy="12" r="9"></circle>'
                + '<path d="M12 1v2M12 21v2M1 12h2M21 12h2"></path></svg></button>');
            parts.push('<span class="dating-decide-label">' + escapeHtml(t('datingFindmeStart')) + '</span>');
            parts.push('</div>');
        } else {
            parts.push('<div class="dating-decide-col">');
            parts.push('<button type="button" class="dating-decide-btn dating-decide-btn--nope" data-dating-cand-decide="0">'
                + '<svg viewBox="0 0 24 24" width="28" height="28" stroke="currentColor" stroke-width="2.5" fill="none">'
                + '<path d="M18 6L6 18"></path><path d="M6 6l12 12"></path></svg></button>');
            parts.push('<span class="dating-decide-label">' + escapeHtml(t('datingNope')) + '</span>');
            parts.push('</div>');
            parts.push('<div class="dating-decide-col">');
            parts.push('<button type="button" class="dating-decide-btn dating-decide-btn--like" data-dating-cand-decide="1">'
                + '<svg viewBox="0 0 24 24" width="28" height="28" fill="currentColor">'
                + '<path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>'
                + '</svg></button>');
            parts.push('<span class="dating-decide-label">' + escapeHtml(t('datingLike')) + '</span>');
            parts.push('</div>');
        }
        parts.push('</div>');
        parts.push('</div>');   // panel

        const el = document.createElement('div');
        el.className = 'dating-cand-overlay';
        el.setAttribute('role', 'dialog');
        el.setAttribute('aria-modal', 'true');
        el.innerHTML = parts.join('');

        document.getElementById('datingScreen').appendChild(el);
        this._candOverlay = el;
        this._candHandle  = c.handle;
        this._candName    = c.displayName || '';   // für Melden/Blockieren-Dialoge
        this._candMatch   = match ? c : null;   // für die [Chat]/[Video]-Handler

        // Punkte mitfuehren. Kein IntersectionObserver noetig: Die Breite EINES Bildes
        // ist die Breite der Spur, also sagt die Scroll-Position direkt, welches steht.
        const track = el.querySelector('.dating-cand-photos');
        const dots  = el.querySelectorAll('.dating-cand-dot');
        if (track && dots.length) {
            track.addEventListener('scroll', () => {
                const i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
                dots.forEach((d, n) => d.classList.toggle('is-active', n === i));
            }, { passive: true });

            // Klick auf einen Punkt springt zum Foto. Die Klasse setzt der scroll-Handler
            // oben — `smooth` scrollt, das feuert `scroll`, und der Punkt zieht nach.
            // Hier nichts doppelt setzen: Das haette zwei Quellen fuer denselben Zustand.
            dots.forEach((d, n) => {
                d.addEventListener('click', () => {
                    track.scrollTo({ left: n * track.clientWidth, behavior: 'smooth' });
                });
            });
        }
    }

    // true = es war etwas offen und wurde geschlossen. Der Zurueck-Knopf fragt danach,
    // bevor er die View wechselt — genau wie beim Match-Dialog.
    closeCandidateOverlay() {
        if (!this._candOverlay) {
            return false;
        }
        this._candOverlay.remove();
        this._candOverlay = null;
        this._candHandle  = '';
        this._candName    = '';
        this._candMatch   = null;
        return true;
    }

    // ── Melden / Blockieren ──────────────────────────────────
    // Pendant zu dating_deck_screen.dart (_showSafetyMenu/_askReportReason/_confirmBlock).
    // Backend: POST /dating/report + /dating/block (routes.js). Melden blockiert mit.

    // Bottom-Sheet mit optionalem Titel/Hinweis und einer Liste von Aktionen. Schliesst bei
    // Auswahl, "Abbrechen" oder Klick auf den Hintergrund. items: [{label, danger?, onSelect}].
    _showSheet(opts) {
        const o = opts || {};
        const parts = ['<div class="dating-sheet" role="dialog" aria-modal="true">'];
        if (o.title) { parts.push('<div class="dating-sheet-title">' + escapeHtml(o.title) + '</div>'); }
        if (o.hint)  { parts.push('<div class="dating-sheet-hint">' + escapeHtml(o.hint) + '</div>'); }
        (o.items || []).forEach((it, i) => {
            parts.push('<button type="button" class="dating-sheet-item' + (it.danger ? ' is-danger' : '')
                + '" data-sheet-item="' + i + '">' + escapeHtml(it.label) + '</button>');
        });
        parts.push('<button type="button" class="dating-sheet-cancel" data-sheet-cancel>'
            + escapeHtml(t('cancel')) + '</button>');
        parts.push('</div>');

        const el = document.createElement('div');
        el.className = 'dating-sheet-overlay';
        el.innerHTML = parts.join('');
        document.getElementById('datingScreen').appendChild(el);

        const close = () => el.remove();
        el.addEventListener('click', (e) => {
            if (e.target === el || e.target.closest('[data-sheet-cancel]')) { close(); return; }
            const btn = e.target.closest('[data-sheet-item]');
            if (!btn) { return; }
            close();
            const item = (o.items || [])[parseInt(btn.getAttribute('data-sheet-item'), 10)];
            if (item && item.onSelect) { item.onSelect(); }
        });
        return el;
    }

    // Sicherheits-Menue (Melden/Blockieren). onDone() laeuft nach erfolgreichem Melden/
    // Blockieren -- der Aufrufer entscheidet, was "danach" heisst: raus aus dem Stapel
    // (Profil im Deck) oder aus der Match-Liste (dating-ui.js). Public, weil auch die
    // Match-Liste es aufruft -- wie showMatchProfile.
    showSafetyMenu(handle, name, onDone, isMatch) {
        const items = [];
        // "Match aufloesen" nur bei einem Match (nicht im Deck-Stapel): loest die Beziehung,
        // entfernt den Kontakt und nimmt den Chat aus der Liste. Kein Block/Report.
        if (isMatch) {
            items.push({ label: t('datingUnmatch'), onSelect: () => this._confirmUnmatch(handle, name, onDone) });
        }
        items.push({ label: t('datingReport'), onSelect: () => this._showReportSheet(handle, name, onDone) });
        items.push({ label: t('datingBlock'), danger: true, onSelect: () => this._confirmBlock(handle, name, onDone) });
        this._showSheet({ items: items });
    }

    // Rueckfrage vor dem Aufloesen mit klarem Hinweis (Gruender-Wunsch): Kontakt weg + Chat
    // aus der Liste. Als Sheet (nicht showConfirm) -- z-index-Grund wie bei _confirmBlock.
    _confirmUnmatch(handle, name, onDone) {
        this._showSheet({
            title: t('datingUnmatchConfirm').replace('{0}', name || ''),
            hint : t('datingUnmatchHint').replace('{0}', name || ''),
            items: [
                { label: t('datingUnmatch'), danger: true, onSelect: () => this._sendUnmatch(handle, onDone) }
            ]
        });
    }

    async _sendUnmatch(handle, onDone) {
        const ok = await VCS.datingCore?.unmatch?.(handle);
        if (!ok) { VCS.ui?.showToast?.(t('datingErrNetwork'), 'error', 5000); return; }
        if (onDone) { onDone(); }
        VCS.ui?.showToast?.(t('datingUnmatchDone'), 'info', 4000);
    }

    // Grund waehlen -- feste Liste, kein Freitext (wie Flutter). Auswahl meldet sofort.
    _showReportSheet(handle, name, onDone) {
        this._showSheet({
            title: t('datingReportTitle'),
            hint : t('datingReportHint').replace('{0}', name || ''),
            items: VCS.DatingCore.REPORT_REASONS.map((reason) => ({
                label: t('datingReport_' + reason),
                onSelect: () => this._sendReport(handle, reason, onDone)
            }))
        });
    }

    // Bestaetigung als Sheet (nicht showConfirm): dessen Overlay laege mit z-index 200
    // HINTER dem Profil-Overlay (1050) und waere unsichtbar. Das Sheet liegt darueber (1200),
    // so bleibt das Profil offen und _removeCandidate kennt danach noch _candMatch.
    _confirmBlock(handle, name, onDone) {
        this._showSheet({
            title: t('datingBlockConfirm').replace('{0}', name || ''),
            hint : t('datingBlockConfirmHint'),
            items: [
                { label: t('datingBlock'), danger: true, onSelect: () => this._sendBlock(handle, onDone) }
            ]
        });
    }

    async _sendReport(handle, reason, onDone) {
        const ok = await VCS.datingCore?.report?.(handle, reason);
        if (!ok) { VCS.ui?.showToast?.(t('datingErrNetwork'), 'error', 5000); return; }
        // Melden blockiert mit -> der Aufrufer nimmt den Kandidaten raus (onDone): im Stapel
        // aus dem Deck, aus der Match-Liste aus den Matches.
        if (onDone) { onDone(); }
        VCS.ui?.showToast?.(t('datingReportDone'), 'info', 4000);
    }

    async _sendBlock(handle, onDone) {
        const ok = await VCS.datingCore?.block?.(handle);
        if (!ok) { VCS.ui?.showToast?.(t('datingErrNetwork'), 'error', 5000); return; }
        if (onDone) { onDone(); }
        VCS.ui?.showToast?.(t('datingBlockDone'), 'info', 4000);
    }

    // Nach Melden/Blockieren aus dem Stapel nehmen (kein Swipe) bzw. -- kam das Profil aus
    // der Match-Liste -- zurueck in die Liste, wo der Geblockte beim Neuladen weg ist.
    _removeCandidate(handle) {
        const wasMatch = !!this._candMatch;
        this.closeCandidateOverlay();
        if (wasMatch) {
            VCS.dating?.showView?.('matches');
            return;
        }
        this._deck = this._deck.filter((x) => x.handle !== handle);
        this._photoIndex = 0;
        this._render();
        if (this._deck.length) {
            this._ensureAllPhotos(this._deck[0]).then(() => {
                this._render();
                this._ensurePhoto(this._deck[1]);
            });
        }
    }

    // ── Match ────────────────────────────────────────────────

    _showMatch(c) {
        this.closeMatchOverlay();

        const url = this._photoUrl(c);
        const el  = document.createElement('div');
        el.className = 'dating-match-overlay';
        el.setAttribute('role', 'dialog');
        el.setAttribute('aria-modal', 'true');
        el.innerHTML =
            '<div class="dating-match-panel">'
            + (url ? '<img class="dating-match-photo" src="' + escapeHtml(url) + '" alt="">' : '')
            + '<h3 class="dating-match-title">' + escapeHtml(t('datingMatchTitle')) + '</h3>'
            + '<p class="dating-match-body">' + escapeHtml(t('datingMatchBody')) + '<br>'
            + escapeHtml(c.displayName || '') + '</p>'
            + '<div class="dating-match-actions">'
            + '<button type="button" class="dating-match-later" data-dating-match-close>'
            + escapeHtml(t('datingMatchLater')) + '</button>'
            // Chat per Handle gibt es noch nicht — bis dahin fuehrt der Match in
            // die Match-Liste statt ins Leere.
            + '<button type="button" class="dating-save dating-match-talk" data-dating-match-talk>'
            + escapeHtml(t('datingMatchTalk')) + '</button>'
            + '</div></div>';

        document.getElementById('datingScreen').appendChild(el);
        this._matchOverlay = el;
        this._matchCand = c; // fuer den "Reden"-Knopf: direkt in den Chat statt in die Liste
        console.log('[dating] Match: handle=' + c.handle);
    }

    // true = es war etwas offen und wurde geschlossen. Der Zurueck-Knopf fragt
    // danach, bevor er die View wechselt.
    closeMatchOverlay() {
        if (!this._matchOverlay) {
            return false;
        }
        this._matchOverlay.remove();
        this._matchOverlay = null;
        return true;
    }

    // ── Events ───────────────────────────────────────────────

    _bindEvents() {
        const body = this._view.body;

        body.on('click', '[data-dating-thumb]', (e) => {
            const i = parseInt($(e.currentTarget).data('dating-thumb'), 10);
            if (!Number.isFinite(i) || i === this._photoIndex) {
                return;
            }
            this._photoIndex = i;
            this._render();
        });

        body.on('click', '[data-dating-deck-go]', (e) => {
            const go = String($(e.currentTarget).data('dating-deck-go'));
            if (go === 'profile') {
                VCS.dating?.showView?.('profile');
                return;
            }
            this._loadDeck();
        });

        body.on('click', '[data-dating-decide]', (e) => {
            this._decide(String($(e.currentTarget).data('dating-decide')) === '1');
        });

        // Profil-Overlay: haengt wie der Match-Dialog an #datingScreen, nicht am
        // Deck-Body — deshalb hier delegieren und nicht dort.
        $('#datingScreen').on('click', '[data-dating-cand-close]', () => {
            this.closeCandidateOverlay();
        });

        // Entscheiden aus dem Profil heraus. Erst schliessen, dann entscheiden: _decide
        // rendert den Stapel neu, und das Overlay soll nicht ueber der naechsten Karte
        // stehen bleiben.
        //
        // Der Guard auf den Handle ist kein Zierrat: _decide arbeitet auf _deck[0].
        // Zwischen Oeffnen und Tippen kann der Stapel weitergelaufen sein (Nachladen,
        // radar-gone) — ohne die Pruefung wuerde die falsche Person geliked, und das
        // nimmt niemand mehr zurueck.
        $('#datingScreen').on('click', '[data-dating-cand-decide]', (e) => {
            const like   = String($(e.currentTarget).data('dating-cand-decide')) === '1';
            const handle = this._candHandle;
            this.closeCandidateOverlay();
            if (!this._deck.length || this._deck[0].handle !== handle) {
                return;
            }
            this._decide(like);
        });

        // Phase 5: [Chat]/[Video] aus dem Profil eines Matches. Beide fragen vorher nach
        // (Wunsch des Gründers) und sprechen den Peer nur über @handle an (Regel 5).
        $('#datingScreen').on('click', '[data-dating-cand-video]', async () => {
            const c = this._candMatch;
            if (!c) return;
            // Erst das Profil schliessen, DANN fragen — wie in Flutter. Sonst liegt der
            // Bestaetigungsdialog (.confirm-overlay, z-index 200) HINTER dem undurchsichtigen
            // Profil-Overlay (.dating-cand-overlay, z-index 1050) und ist unsichtbar/tot.
            this.closeCandidateOverlay();
            const ok = await VCS.ui?.showConfirm?.(
                t('confirmStartVideoCall').replace('{0}', c.displayName || ''), '', t('datingVideoCall'));
            if (!ok) return;
            // Match ist ein echter Kontakt -> ueber die echte Nummer anrufen (nicht @handle),
            // damit es derselbe Chat/Kontakt ist wie in der Liste. Fallback @handle nur fuer
            // alte Matches ohne Kontakt.
            VCS.chatContacts?.callContact?.(c.peerPhone || ('@' + c.handle), c.displayName || '', 'video');
        });
        $('#datingScreen').on('click', '[data-dating-cand-chat]', async () => {
            const c = this._candMatch;
            if (!c) return;
            this.closeCandidateOverlay();
            const ok = await VCS.ui?.showConfirm?.(
                t('datingChatConfirm').replace('{0}', c.displayName || ''), '', t('datingChatAction'));
            if (!ok) return;
            if (!VCS.state.chatMyPhone) return;
            // Echte Nummer (echter Kontakt seit dem Match) -> derselbe Chat wie in der Liste.
            const peerId = c.peerPhone || ('@' + c.handle);
            const chatId = [VCS.state.chatMyPhone, peerId].sort().join('_');
            // #datingScreen ist ein eigener Vollbild-Screen — openConversation schaltet nur
            // die Tabs INNERHALB von #appShell um und ließe den Dating-Screen oben liegen
            // (der Chat öffnete darunter). Erst zurück in die Shell (Chats-Tab), dann öffnen.
            VCS.nav?.showAppShell?.('tabChats');
            VCS.chatSetup?.openConversation?.(chatId, peerId, c.displayName || '');
        });
        // „Finde mich"-Spiel aus dem Match-Profil. Kein Bestaetigungsdialog — die
        // Einladung IST die Frage, der andere muss aktiv annehmen.
        $('#datingScreen').on('click', '[data-dating-cand-findme]', () => {
            const c = this._candMatch;
            if (!c) return;
            this.closeCandidateOverlay();
            VCS.datingFindme?.invite?.(c.handle, c.displayName || '');
        });
        // Drei-Punkte-Menue im Profil: Melden/Blockieren. Handle/Name aus dem offenen
        // Profil -- gilt fuer Stapel- und Match-Profile gleichermassen.
        $('#datingScreen').on('click', '[data-dating-cand-safety]', () => {
            if (!this._candHandle) return;
            const handle = this._candHandle;
            this.showSafetyMenu(handle, this._candName, () => this._removeCandidate(handle), !!this._candMatch);
        });

        // Der Match-Dialog haengt an #datingScreen, nicht am Deck-Body.
        $('#datingScreen').on('click', '[data-dating-match-close]', () => {
            this.closeMatchOverlay();
        });
        $('#datingScreen').on('click', '[data-dating-match-talk]', () => {
            const c = this._matchCand;
            this.closeMatchOverlay();
            // Phase 5: direkt in den Chat mit dem frisch Gematchten (@handle). Fallback auf
            // die Match-Liste, falls die Kandidatendaten fehlen.
            if (c && c.handle && VCS.state.chatMyPhone) {
                const peerId = '@' + c.handle;
                const chatId = [VCS.state.chatMyPhone, peerId].sort().join('_');
                VCS.chatSetup?.openConversation?.(chatId, peerId, c.displayName || '');
            } else {
                VCS.dating?.showView?.('matches');
            }
        });
    }
};
